<div class="rowView" [@slideInOutAnimation]>
    <div class="header">
        <div class="header_sec">
            <div class="vehicle_no">{{vehicle_number}}</div>
            <div style="cursor: pointer;" (click)="closeModal();"> <img src="assets/close-icon-new.svg" alt=""
                    style="cursor: pointer;"> </div>
        </div>

    </div>
    <div class="body">


        <div class="cards">

            <div class="cards_sec eqWrap" *ngFor="let row of rowData">
                <div class="cards_list item">
                    <div class="title">{{row.name}}</div>
                    <div class="count">{{row.value === 0 ? 0 : row.value || 'N/A'}}</div>
                </div>
            </div>
        </div>
    </div>

</div>